// extracted by mini-css-extract-plugin
export default {"resizePageRight":"resizePageRight_resizePageRight__xaOM4","dividerLine":"resizePageRight_dividerLine__+lnm0","uploadPageShell":"resizePageRight_uploadPageShell__dBQ6c"};